/* -------------------------- */
/* Theme custom JavaScript.   */
/* -------------------------- */

!function($) {

    // Document ready
    $(function() {
      
      // Only call these functions on product page
      if ( $('html').hasClass('template-product') ){

        // Re-arrange product info to tabs on product page
        productTabs();

        // Show and hide product pictures
        toggleProductPictures(); 

        // Force user to first select size. See also template-product.js and component-product-form.js
        productSizeChanges(); 

      }

    });

  // Functions
  function productTabs() {
  
    // Create variables for tabs content
    $features = $('.tabs-content #tab1').children();
    $materials = $('.tabs-content #tab2').children();
    $size = $('.tabs-content #tab3').children();
    
    // Some products don't have instructions
    if ( $('.tabs-content #tab4').length > 0 ) {
        $instructions = $('.tabs-content #tab4').children();
        $('.tab-instructions .tab-content__inner').append($instructions);
    } else {
        $('.tab-instructions').remove();
    }
    
    // Add content to new tabs
    $('.tab-features .tab-content__inner').append($features);
    $('.tab-materials .tab-content__inner').append($materials);
    $('.tab-size .tab-content__inner').append($size);

    // Remove description header
    $('.product__description h2').remove();
    
    // Description as tab is optionary 
    if ( $('.tab-description').length > 0 ) {
        $description = $('.product__description').children().not('.tabs,.tabs-content');
        $('.tab-description .tab-content__inner').append($description);
        $('.product__description').remove();
    } else {
        $('.product__description .tabs, .product__description .tabs-content').remove();
        $('.product__description').removeClass('hidden');
    }
    
    // Add heights for tabs and collapse them
    $('.tab-content').each( function() {
        var height = $(this).outerHeight();
        $(this).data('height', height);
        $(this).css('height', 0);
    });
    
    // Show and hide tabs content on click. 
    $('.description-tabs .tab h3').click( function() {
    
        var $currentTab = $(this).parent();
        
        if ($currentTab.hasClass('active')) {
            $currentTab.toggleClass('active').find('.tab-content').css('height', 0);
        } else {
            var height = $currentTab.find('.tab-content').data('height');
            $currentTab.toggleClass('active').find('.tab-content').css('height', height + 'px');
        }
    
    });
  
  }

  function toggleProductPictures() {

    // jQuery objects
    $picturesButton = $('.gridy-slider.product-media-slider #show-product-pictures');
    $productMedia = $('.gridy-slider.product-media-slider .product-media:nth-child(n+5)');
    
    // Event handler for pictures button clicks
    $picturesButton.click(function() {

      // Show additional pictures if they are hidden
      if ( $picturesButton.text() == 'Mehr anzeigen' ) {
        $picturesButton.text('Weniger anzeigen');
        $('gridy-slider .button-container').addClass('active');
        $productMedia.addClass('visible');
      } else {
        // Hide additional pictures if they are visible
        $productMedia.removeClass('visible');
        $picturesButton.text('Mehr anzeigen');
        $('gridy-slider .button-container').removeClass('active');
        let rect = $('gridy-slider')[0].getBoundingClientRect();
        window.scroll('',rect.y);
      }
      
    });

      // Event handler for color change
      $('variant-radios fieldset[data-option="Farbe"] input[type="radio"]:nth-of-type(n+2)').click(function() {

          // Show additional pictures if picture for active color is hidden
          const activeColor = $(this).val().split(' ')[0]; 
          const activeColorIsHidden = $('.gridy-slider.product-media-slider .product-media').slice(0,4).find('img').toArray().some(img => 
            $(img).attr('srcset') && !$(img).attr('srcset').includes(activeColor)
          );

          if ( activeColorIsHidden ) {
            $picturesButton.text('Weniger anzeigen');
            $productMedia.addClass('visible');
            setTimeout(function() {
              $('gridy-slider .button-container').addClass('active');
            }, 500);
          }
        
    });
 
  }

  function productSizeChanges() {

    // Click event handler for size radio inputs
    $(document).on('click', 'variant-radios input[name="Größe"]', function () {

      // If default size is in use, set 
      if (this.checked == true) {
        $('fieldset[data-option="Größe"] legend strong').text($(this).val());
      }

      // Set default size data attribute to false as user has now selected a size
      document.querySelector('variant-radios').setAttribute('data-default-size','false');

      // If size error is visible, hide it
      if ($('.product-form__error-message-wrapper').is(':visible') && $('.product-form__error-message').text() == 'Wählen Sie zuerst die Größe') {
        $('product-form')[0].handleErrorMessage();
      }

    });

  }

}(jQuery);